module.exports = __webpack_public_path__ + "static/img/mobile.189236b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile.png
// module id = HXsc
// module chunks = 36